import {
    Agenda,
    AgendaAbogacia
} from "../components/Agenda";

const routesAgenda = [
    {
        path: "/agenda-calendario",
        name: "Calendario",
        icon: "nc-icon nc-calendar-60",
        component: <Agenda />,
        permissions: ['92_CALENDARIO'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/agenda-juridico",
        name: "Agenda Jurídico",
        icon: "nc-icon nc-calendar-60",
        component: <AgendaAbogacia />,
        permissions: ['251_JURIDICO'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    }
]

export {
    routesAgenda
}